import { QueryClient } from '@tanstack/react-query';

// Every list that shows LeaveRequest rows (and the balances and previews counted from them), so a submit,
// withdraw, cancel, review or archive refreshes all of them.
const LEAVE_REQUEST_QUERY_KEYS = [
  'hr-leave-requests',
  'hr-manage-leave-requests',
  'hr-leave-overview',
  'hr-leave-sheet',
  'hr-leave-calendar',
  'hr-sick-leave-requests',
  'hr-leave-request-balance',
  'hr-leave-request-preview',
];

export const invalidateLeaveRequestQueries = (queryClient: QueryClient) =>
  Promise.all(
    LEAVE_REQUEST_QUERY_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: [key] }))
  );
